import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
const styles = theme => ({
    root: {
      flexGrow: 1,
      maxWidth: 1170,
      margin: 'auto',
    }
});
class SectionDebt extends Component {
    render() {
        const { classes } = this.props;
        return (
            <section className="debts">
                <div className={classes.root}>
                    <Grid item xs={12} container>
                        <Grid item sm={6} xs={12} className="section_left">
                            <div className="">
                                <p className="debs_content">
                                Over <span className="debtTextHighlight">44 million Americans</span> are affected by student loan debt, the largest personal financial burden our country faces today.
                                </p>
                                <Grid item xs={12} container>
                                    <Grid item sm={4} xs={12} className="debtInfo">
                                        <img className="debtStatsImage" src={require('../../assets/images/stat1.png')} />
                                        <div className="debtStatContent">
                                            <p className="debtStatContentTitle">$1.4 Trillion</p>
                                            <p className="debtStatContentDesc">
                                                and counting in student loan debt in 2017, affecting 3 out of 4 graduates 1
                                            </p>
                                        </div>
                                    </Grid>
                                    <Grid item sm={4} xs={12} className="debtInfo">
                                        <img className="debtStatsImage" src={require('../../assets/images/stat2.png')} />
                                        <div className="debtStatContent">
                                            <p className="debtStatContentTitle">$37k</p>
                                            <p className="debtStatContentDesc">
                                                is the average amount of student loan debt 2
                                            </p>
                                        </div>
                                    </Grid>
                                    <Grid item sm={4} xs={12} className="debtInfo">
                                        <img className="debtStatsImage" src={require('../../assets/images/stat3.png')} />
                                        <div className="debtStatContent">
                                            <p className="debtStatContentTitle">19.7 years</p>
                                            <p className="debtStatContentDesc">
                                            is the average length to pay off a bachelor's degree 3
                                            </p>
                                        </div>
                                    </Grid>
                                </Grid>
                            </div>
                        </Grid>
                        <Grid item sm={6} xs={12} className="section_right">
                            <div className="">
                                <img className="debtImage" src={require('../../assets/images/eclipse.png')} />
                            </div>
                        </Grid>
                        
                    </Grid>
                </div>
            </section>
        )
    }
}
SectionDebt.propTypes = {
    classes: PropTypes.object.isRequired,
  };
export default withStyles(styles)(SectionDebt);


// WEBPACK FOOTER //
// ./src/components/Landing/SectionDebt.js